import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";

import commonStyle from "../../content/CommonStyles.module.css";

const DropdownInput = ({formik, paramName, context, value, label, isDisabled, isMobile, customStyle="", onChange, addButton, addButtonTooltip, addButtonAction, hintText, mandatory}) => {
    return (
        <div className={`${commonStyle.formInput} ${!isMobile ? "" : "w-11"} ${customStyle}`}>
            <div className="p-inputgroup flex-column">
                <FloatLabel>
                    <Dropdown value={value ?? formik?.values[paramName]}
                        onChange={(e) => onChange(e.value)}
                        options={context}
                        optionLabel="label"
                        optionValue="value"
                        disabled={isDisabled}
                        showClear
                        className={formik?.errors[paramName] && formik?.touched[paramName] ? 'p-invalid w-full' : "w-full"} />
                    {addButton && <Button
                        icon="pi pi-plus"
                        className={commonStyle.addButton}
                        severity="success"
                        disabled={isDisabled}
                        tooltip={addButtonTooltip ?? "Додати"}
                        tooltipOptions={{position: "top"}}
                        type="button"
                        onClick={addButtonAction}
                    />}
                    <label>{label}{mandatory && <span className={commonStyle.requiredAsterisk}>*</span>}</label>
                </FloatLabel>
                {formik?.errors[paramName] && formik?.touched[paramName] && (<small className={commonStyle.errorSmall}>{formik?.errors[paramName]}</small>)}
                {hintText && (<small>{hintText}</small>)}
            </div>
        </div>
    )
}

export default DropdownInput;